<script>
    import Icon from '../icon/Icon.svelte';
    import Avatar from '../avatar/Avatar.svelte';

    // Model for group, student, chapter, etc to base the label on
    export let model

    // Optional text before the label
    export let labelPrefix = ''

    // Optional text after the label
    export let labelSuffix = ''

    // If possible, use a short version of the index. Activity can be B instead of 1.3 B
    export let isCompact = false

    // Use 14px instead of 16px for font size
    export let smallText = false

    // Style the label for displaying on a dark background
    export let isOnBackground = false

    // URL to use if the label should be an a tag with href attribute
    export let link = null

    // For users, start with their first name instead of last name
    export let displayFirstNameFirst = false

    // Use ellipsis when name does not fit (instead of expanding the label)
    export let truncateName = false

    // If omitted, use icon from model instead (recommended)
    export let icon = null

    const tagName = link ? 'a' : 'div'

    const {label, title, index, icon: modelIcon} = model.getLabel({isCompact, displayFirstNameFirst})
    const resolvedIcon = icon || modelIcon

    const avatar = setAvatar()

    function setAvatar() {
        if (['student', 'teacher', 'user'].includes(model.constructor.type)) {
            return model.get('avatar')
        }
    }
</script>

<svelte:element
    this={tagName}
    href={link}
    class="label"
    class:small-text={smallText}
    class:is-on-background={isOnBackground}
    class:is-clickable={link}
    {title}>

    {#if labelPrefix}
        <span class="prefix">{labelPrefix}</span>
    {/if}

    <span class="index" class:has-avatar={avatar}>
        {#if avatar}
            <Avatar {avatar} {model}></Avatar>
        {:else if resolvedIcon}
            <Icon name={resolvedIcon}></Icon>
        {:else if index}
            {index}
        {/if}
    </span>

    <span component="content-label__name" class:truncate-name={truncateName}>{label}</span>

    {#if labelSuffix}
        <span class="suffix">{labelSuffix}</span>
    {/if}

</svelte:element>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.label {
  font-size: 16px;
  color: #122d40;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: 100%;
}
.label.small-text {
  font-size: 14px;
}
.label.is-clickable:hover {
  color: hsl(205, 60%, 44%);
}
.label.is-clickable:focus {
  outline-offset: -1px;
}
.label.is-on-background {
  color: #fff;
}
.label.is-on-background .index {
  background: rgba(18, 45, 64, 0.5);
  color: #fff;
}
.label.is-on-background.is-clickable:hover {
  color: #fff;
  text-decoration: underline;
}
.label.is-on-background.is-clickable:hover .index {
  background: #122d40;
  color: #fff;
}
.label .prefix {
  margin-right: 8px;
  color: currentColor;
}
.label .index {
  display: inherit;
  align-items: inherit;
  justify-content: center;
  flex-shrink: 0;
  padding: 8px;
  margin-right: 8px;
  min-width: 32px;
  border-radius: 12px;
  background: rgba(17.6%, 48.4%, 70.4%, 0.1);
  color: hsl(205, 60%, 44%);
  white-space: nowrap;
  line-height: 1;
}
.label .index.has-avatar {
  padding: 0;
  border: 0;
  background: transparent;
  min-width: 0;
}
.label .index :global(svg) {
  width: 16px;
  height: 16px;
}
.label .truncate-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.label .suffix {
  margin-left: auto;
  text-align: right;
}

@media print {
  .label {
    color: #122d40;
    font-size: 1em;
  }
  .label .index {
    color: inherit;
    background: none;
  }
}</style>
